import { Strapi4ResponseData } from "@nuxtjs/strapi";
import {
  StrapiSingleType,
  StrapiImage,
  StrapiResponsiveImage,
  StrapiField,
  StrapiLabel,
} from "~/types/strapi";

export enum StrapiSpecialOrdersType {
  plasticBagsWithHandles = "Plastic bags with handles",
  tapes = "Tapes",
  otherSpecialOrders = "Other special orders",
  packagingPaperBags = "Packaging paper bags",
  plasticDishes = "Plastic dishes",
  corrugatedBoxes = "Corrugated boxes",
  labels = "Labels",
  plasticBagsForPackaging = "Plastic bags for packaging",
  paperBagsWithHandles = "Paper bags with handles",
  boxes = "Boxes",
  filmTapes = "Film tapes",
  bagsOfDifferentMaterials = "Bags of different materials",
  multiLayerBags = "Multi-layer bags",
}

export interface StrapiSpecialOrders extends StrapiSingleType {
  title: string;
  slug: string;
  banner: StrapiResponsiveImage;
  cover: {
    data: Strapi4ResponseData<StrapiImage>;
  };
  ourWorks: {
    data: Strapi4ResponseData<StrapiImage>[];
  };
  fields: StrapiField[];
  labels: StrapiLabel[];
  type: StrapiSpecialOrdersType;
}
